import React from 'react';
import PropTypes from 'prop-types';

import noop from 'lodash/noop';

import { Modal } from 'antd';
import Input from '@views/Input';

export const RankingCreate = ({
  visible,
  saving,
  onOk,
  onCancel,
  canSave,
  name,
  onChangeName,
  editMode,
}) => (
  <Modal
    title={editMode ? 'Editar Nombre' : 'Nuevo Torneo'}
    visible={visible}
    onOk={canSave ? onOk : noop}
    confirmLoading={saving}
    onCancel={saving ? noop : onCancel}
    cancelText="Cancelar"
    okText={editMode ? 'Guardar' : 'Crear'}
    destroyOnClose
    okButtonProps={{ className: 'mbutton mbutton-primary ranking-create-btn' }}
    cancelButtonProps={{ className: 'mbutton mbutton-secondary' }}
  >
    <Input
      size="large"
      placeholder="Nombre (mínimo 6)"
      value={name}
      onChange={onChangeName}
    />
    {(name || '').length < 6 ? (
      <p>El nombre de torneo debe tener al menos 6 caracteres</p>
    ) : null}
  </Modal>
);

RankingCreate.displayName = 'RankingCreate';
RankingCreate.propTypes = {
  visible: PropTypes.bool,
  name: PropTypes.string,
  canSave: PropTypes.bool,
  saving: PropTypes.bool,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  onChangeName: PropTypes.func,
  editMode: PropTypes.bool,
};

RankingCreate.defaultProps = {
  visible: false,
  name: '',
  canSave: false,
  saving: false,
  onOk: noop,
  onCancel: noop,
  onChangeName: noop,
  editMode: false,
};

export default RankingCreate;
